import HundredBricksAPIError from '../../HundredBricksAPIError';
class ResendEmailTokenError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ResendEmailTokenError', ...args);
    }
}
export default ResendEmailTokenError;
